module.exports = __webpack_public_path__ + "static/phone-f4880d9f176be3a212b826476bbe20ad.svg";